import { type FC } from 'react';
import cn from 'classnames';

import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import starsPatternPng from '/img/patterns/stars.png';
import starsPatternWebp from '/img/patterns/stars.webp';

const Background: FC = () => {
  return (
    <div className={css.diceGameBg}>
      <div className="relative w-full h-full flex flex-col justify-end">
        <div
          style={{
            top: -228,
          }}
          className={cn(css.elipse)}
        ></div>
        <Picture
          className="absolute w-full aspect-[444.21/443.02] left-1/2 top-0 -translate-x-1/2"
          img={starsPatternPng}
          webp={starsPatternWebp}
          alt="stars pattern"
        />
        <div className={css.radialBg}></div>
      </div>
    </div>
  );
};

export { Background };
